/**
 * Shy header — scroll-direction detector.
 *
 * Toggles `html.shy` CSS class based on scroll direction.
 * CSS custom properties (--shy-shift) handle all visual positioning;
 * this component only manages the class toggle.
 */

const DIRECTION_DELTA = 6;

export default () => ({
  _visible: true,
  _commitY: 0,
  _rafId: 0,
  _topLock: 0,

  init() {
    this._topLock = this.$el.offsetHeight;
    this._commitY = Math.max(0, window.scrollY);
    window.addEventListener('scroll', () => this._scheduleUpdate(), { passive: true });
    this.$watch('$store.menuOpen', (open) => { if (open) this._forceVisible(); });
    this.$watch('$store.modal.current', (val) => { if (val) this._forceVisible(); });
  },

  _scheduleUpdate() {
    if (this._rafId) return;
    this._rafId = requestAnimationFrame(() => {
      this._rafId = 0;
      this._updateVisibility();
    });
  },

  _updateVisibility() {
    const y = Math.max(0, window.scrollY);
    let next = this._visible;

    if (y <= this._topLock || this.$store.menuOpen || this.$store.modal?.current) {
      next = true;
    } else if (y > this._commitY + DIRECTION_DELTA) {
      next = false; // scrolling down → hide
    } else if (y < this._commitY - DIRECTION_DELTA) {
      next = true; // scrolling up → show
    }

    if (next !== this._visible) {
      this._visible = next;
      this._commitY = y;
      document.documentElement.classList.toggle('shy', !next);
    } else if (
      (!this._visible && y > this._commitY) ||
      (this._visible && y < this._commitY)
    ) {
      // Drift baseline when continuing in the same direction
      this._commitY = y;
    }
  },

  _forceVisible() {
    this._visible = true;
    this._commitY = Math.max(0, window.scrollY);
    document.documentElement.classList.remove('shy');
  },

  destroy() {
    if (this._rafId) cancelAnimationFrame(this._rafId);
  },
});
